import FileComments from './FileComments';

export default FileComments;
